import React from 'react'
import HospitalClaimDetails from '../HospitalClaimDetails/HospitalClaimDetails'
import FuneralClaimDetails from '../FuneralClaimDetails/FuneralClaimDetails'
import DisabilityClaimDetails from '../DisabilityDetails/DisabilityClaimDetails'

export default function AdditionalDetails(props) {


  if(props.hasHospiCashIllnessBenefit || props.hasHospiCashAccidentBenefit){
    return <HospitalClaimDetails {...props} />
  }
  // showFuneralDetails covers the benefit flags below plus the OMK fallback
  // (see ClaimInitiation/index.js) so the death capture form — and with it the
  // cause of death dropdown — always renders for a death claim.
  if(props.showFuneralDetails || props.hasFuneralNaturalDeath || props.hasFuneralAccidentalDeath || props.hasAccidentalDeathBenefit || props.hasNaturalDeathBenefit || props.isMalawiFuneralBenefits){
    return <FuneralClaimDetails {...props} />
  }
  if(props.hasPartialPermanentDisabilityBenefit || props.hasTotalPermanentDisabilityBenefit){
    return <DisabilityClaimDetails {...props} />
  }


  

  
}
